import { createContext, useContext } from 'react';

import type { VideoUploadControls } from '@/video/useVideoUpload';

// The provisional video placeholder lives inside the editor as a Tiptap NodeView,
// so it cannot receive the upload controls as props. Tiptap renders React node
// views through portals under <EditorContent>, so a provider wrapping the composer
// reaches them. null when the host did not enable uploads.
export const VideoUploadContext = createContext<VideoUploadControls | null>(null);

export const useVideoUploadContext = () => useContext(VideoUploadContext);
